import {WsClient} from 'wix-ws-ng-client';

class PubSubPOC {
  constructor({log}) {
    const wsUrl = window.__WIX_WS_URL__ || 'wss://engage.wixapps.net/wix-ws-ng-server';
    this.service = new WsClient(wsUrl);
    this.log = log;
    this.rooms = {};
    this.numberOfTimesNsConnected = 0;
    this.numberOfTimesOpened = 0;

    this.service.on('open', () => {
      if (this.numberOfTimesOpened === 0) {
        this.log('connect');
      } else {
        this.log('reconnect', {count: this.numberOfTimesOpened});
      }

      this.numberOfTimesOpened++;
    });

    this.service.on('close', err => {
      if (err) {
        this.log('close_error', err);
      }
    });
  }

  start() {
    this.initInstructionsChannel();
  }

  stop() {
    this.socket && this.socket.disconnect();
  }

  initInstructionsChannel() {
    this.socket = this.service.connect({apiKey: '1'});
    const instructionsChannel = this.socket.subscribe('inst');
    this.registerSubscribeEvents(instructionsChannel, 'inst');

    this.socket.on('connect', () => {
      this.numberOfTimesNsConnected++;

      if (this.numberOfTimesNsConnected > 1) {
        this.log('reconnect_ns', {count: this.numberOfTimesNsConnected - 1});
      }
    });

    instructionsChannel.on('applySubscribe', payload => {
      const channel = payload.channel;
      const room = this.rooms[channel] = this.socket.subscribe(channel);
      this.registerSubscribeEvents(room, payload.channel);
      room.on('event', payload => this.log('event', {channel, ...payload}));
    });

    instructionsChannel.on('applyUnsubscribe', payload => {
      const channel = payload.channel;
      const room = this.rooms[channel];

      if (room !== undefined) {
        this.registerUnsubscribeEvents(room, channel);
        room.unsubscribe();
      }
    });
  }

  registerSubscribeEvents(channel, channelName) {
    this.log('doSubscribe', {channel: channelName});
    channel.on('subscribe', () => this.log('subscribe', {channel: channelName}));
  }

  registerUnsubscribeEvents(channel, channelName) {
    this.log('doUnsubscribe', {channel: channelName});
    channel.on('unsubscribe', () => this.log('unsubscribe', {channel: channelName}));
  }
}

export default params => new PubSubPOC(params);



// WEBPACK FOOTER //
// ./chat-app/services/wixPubSub.js